import styled from 'styled-components'

export const LayoutWrapper = styled.div`
    font-family: 'Muli', sans-serif;
    font-size: ${props => props.theme.admin.font.size};
    display: flex;
    flex-direction: column;
    height: 100vh;

    .ck.ck-dropdown .ck-dropdown__panel.ck-dropdown__panel_sw {
        width: 250px;
    }

    .ck.ck-toolbar-dropdown .ck.ck-toolbar .ck.ck-toolbar__items {
        flex-wrap: wrap;
    }
`

export const Header = styled.div`
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-basis: 40px;
    padding: 0px 15px;
    background-color: ${props => props.theme.admin.colors.brandDark};
    z-index: 20;
`

export const Wrapper = styled.div`
    flex: 1;
    display: flex;
    width: 100%;
    height: 100%;
`

export const BodyLoading = styled.div`
    flex: 1;
    overflow: hidden auto;
    height: calc(100vh - 40px);
    display: flex;
    justify-content: center;
    align-items: center;
`
